import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import UserPermissions from "components/Staff/UserPermissions";

const StaffModal = ({
  isOpen,
  toggle,
  formData,
  handleInputChange,
  handleSubmit,
  permissions,
  setPermissions,
  rolesList,
  loading,
  errors,
  disabledSubmit,
  type
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isAddMode = type === "add";

  const validRole = () => {
    return ["kitchen-cook", "kitchen-admin", "kitchen-waiter"].some((role) =>
      formData.role.includes(role)
    );
  };

  const renderPasswordInput = () => (
    <FormGroup>
      <Label for="password">Password</Label>
      <InputGroup>
        <Input
          type={showPassword ? "text" : "password"}
          name="password"
          id="password"
          autoComplete="off"
          required
          placeholder="Password"
          value={formData.password}
          onChange={handleInputChange}
          invalid={!!errors.password}
        />
        <InputGroupText
          onClick={() => setShowPassword((prev) => !prev)}
          role="button"
          style={{ cursor: "pointer" }}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </InputGroupText>
      </InputGroup>
      <p
        style={{
          fontSize: "12px",
          color: "red",
          marginTop: "5px"
        }}
      >
        {errors}
      </p>
    </FormGroup>
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {isAddMode ? "Add Staff" : "Edit Staff"}
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="name">Full Name</Label>
            <Input
              type="text"
              name="name"
              id="name"
              required
              autoComplete="off"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleInputChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="email">Email</Label>
            <Input
              type="email"
              name="email"
              id="email"
              required
              autoComplete="off"
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
              disabled={!isAddMode}
            />
          </FormGroup>

          {isAddMode && renderPasswordInput()}

          <FormGroup>
            <Label for="role">Role</Label>
            <Input
              type="select"
              name="role"
              id="role"
              required
              value={formData.role}
              onChange={handleInputChange}
            >
              {rolesList.map(({ value, label, disabled }) => (
                <option key={value} value={value} disabled={disabled}>
                  {label}
                </option>
              ))}
            </Input>
          </FormGroup>

          {formData.role &&
            formData.role !== "role" &&
            Object.keys(permissions || {}).length > 0 && (
              <UserPermissions
                permissions={permissions}
                setPermissions={setPermissions}
                role={formData.role}
              />
            )}

          <div className="d-flex justify-content-end mt-3">
            <Button color="primary" disabled={loading || !validRole()}>
              {loading ? <Spinner size="sm" /> : "Save"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default StaffModal;
